// extracted by mini-css-extract-plugin
export default {"childrenWrapper":"mimic___styles_childrenWrapper__aC8l-","childrenContainer":"mimic___styles_childrenContainer__3lL3j"};